<template>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refProductCost'
        :data-source='productCostInfo'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="false"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="seqId"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxGrouping :auto-expand-all="isExpandAll"/>
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          file-name="완제품원가내역"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumn
          v-if="$store.getters.getGroupName !== null"
          :caption="$store.getters.getGroupName"
          data-field="차종"
          width="80"
        >
        </DxColumn>
        <DxColumn
          :group-index="0"
          data-field="완제품코드"
        />
        <DxColumn
          :allowEditing='true'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
        >
        </DxColumn>
       <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
          :visible='true'
          width='80'

        >
          <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='true'
          width='120'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="공정유형"
          data-field="공정유형"
          :visible='true'
          width='80'
        >
          <DxLookup
            :data-source="processingTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          caption="재료비정보"
          alignment='center'
        >
          <DxColumn
            :allowEditing="true"
            caption="외주프레스품가격"
            data-field="외주프레스가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="코일가격"
            data-field="코일가격"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="스크랩가격"
            data-field="스크랩가격"
            :visible='true'
            dataType="number"
            format='#,##0.00'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="H/W가격"
            data-field="자재가격"
            :visible='true'
            dataType="number"
            format='#,##0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="재료비소계"
            data-field="재료비소계"
            :visible='true'
            dataType="number"
            format='#,##0.0'
          >
          </DxColumn>
          <DxColumn
            :allowEditing="true"
            caption="(스크랩중량)"
            data-field="자사스크랩중량"
            :visible='true'
            dataType="number"
            format='#,##0.00000'
          >
          </DxColumn>
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="도급비용"
          data-field="도급비용"
          :visible='true'
          dataType="number"
          format='#,##0'
        >
        </DxColumn>
        <DxColumn
          :allowEditing="true"
          caption="원가합계"
          :calculate-cell-value="calcCostSum"
          :visible='true'
          dataType="number"
          format='#,##0.0'
        >
        </DxColumn>
        <DxSummary>
          <DxGroupItem
            column="품번"
            summary-type="count"
            display-format="{0} 건"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.0'
            summary-type="sum"
            column="외주프레스가격"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.0'
            summary-type="sum"
            column="코일가격"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.00'
            summary-type="sum"
            column="스크랩가격"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.0'
            summary-type="sum"
            column="자재가격"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.0'
            summary-type="sum"
            column="재료비소계"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.00000'
            summary-type="sum"
            column="자사스크랩중량"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.0'
            summary-type="sum"
            column="도급비용"
            display-format="{0}"
          />
          <DxGroupItem
            :show-in-group-footer="false"
            :align-by-column="true"
            value-format='#,##0.0'
            summary-type="sum"
            column="원가합계"
            display-format="{0}"
          />
        </DxSummary>
        <DxSortByGroupSummaryInfo summary-item="count"/>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
        <template #scrap-price-date>
          <div class="toolbar-label" style='font-size:1.2rem;margin-left:10px;'>
            <b>  스크랩단가 : {{scrapPrice}}원</b>
          </div>
        </template>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport,
  DxSummary, DxGroupItem, DxSortByGroupSummaryInfo, DxGrouping,
  DxColumn, DxPaging, DxSorting, DxSearchPanel, DxLookup } from 'devextreme-vue/data-grid'

export default {
  name: 'ProductMaterialCost',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '완제품 원가내역'
        }
      ],
      productCostInfo: null,
      itemTypeLookup: null,
      meterialTypeLookup: null,
      processingTypeLookup: null,
      selectedRow: null,
      productCostInfoDetail: null,
      gridHeightTree: null,
      isExpandAll: true,
      today: AppLib.getToday(),
      scrapPrice: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxGroupItem,
    DxGrouping,
    DxSortByGroupSummaryInfo
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshScrapPrice()
    this.refreshProductCost()
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.processingTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcCostSum (row) {
      return (row.재료비소계 + row.도급비용)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>기준일:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 94,
            value: this.today,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.today = args.value
              this.refreshScrapPrice()
              this.refreshProductCost()
            }
          }
        },
        {
          location: 'before',
          template: 'scrap-price-date'
        },
        {
          location: 'after',
          widget: 'dxCheckBox',
          options: {
            value: this.isExpandAll,
            text: '노드확장',
            onValueChanged: (args) => {
              this.isExpandAll = args.value
            }
          }
        }
      )
    },
    refreshProductCost () {
      this.isLoading = true
      this.$_sp.runNoEncodeFindProc('spFindAllMaterialCost', { 품번: 'ALL', 기준일: this.today })
        .then((data) => {
          this.isLoading = false
          this.productCostInfo = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshScrapPrice () {
      this.$_sp.runNoEncodeFindProc('spFindAllScrapPriceByDate', { date: this.today })
        .then((data) => {
          let result = this.$_sp.MakeModel(data)
          if (result.length === 0) {
            this.$snotify.error('해당일 기준 등록된 스크랩 단가가 없습니다.')
          } else {
            this.scrapPrice = result[0].가격
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
